module.exports = __webpack_public_path__ + "img/aParty_110923_A.89693ae4.jpg";